import React from 'react';
import { MapPin, Phone, Mail, Navigation } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';
import './HomeContact.css';

const HomeContact = () => {
    const { settings } = useSettings();
    const mapEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(settings.address || '102 rue Porta, 81000 Albi')}&output=embed`;
    return (
        <section className="home-contact-section">
            <div className="home-contact-grid">
                {/* Visual Map Side - Left */}
                <div className="home-contact-map">
                    <iframe
                        src={mapEmbedUrl}
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        title="Localisation Pâtisserie Millet"
                    ></iframe>
                </div>

                {/* Info Side - Right */}
                <div className="home-contact-info">
                    <div className="info-content-wrapper">
                        <span className="info-subtitle">L'Adresse Gourmande</span>
                        <h2 className="info-title">Venez nous voir</h2>
                        <div className="info-divider"></div>

                        <div className="info-items">
                            <div className="info-item">
                                <div className="info-icon-circle">
                                    <MapPin size={22} />
                                </div>
                                <div className="info-text">
                                    <h4>Notre Boutique</h4>
                                    <p>{settings.address}</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <div className="info-icon-circle">
                                    <Phone size={22} />
                                </div>
                                <div className="info-text">
                                    <h4>Une question ?</h4>
                                    <p>{settings.phone}</p>
                                </div>
                            </div>

                            <div className="info-item">
                                <div className="info-icon-circle">
                                    <Navigation size={22} />
                                </div>
                                <div className="info-text">
                                    <h4>Stationnement</h4>
                                    <p>Parking Arnaud Beltrame (Gratuit)</p>
                                </div>
                            </div>
                        </div>

                        <div className="info-actions">
                            <a href={`mailto:${settings.email}`} className="btn-contact">
                                <Mail size={18} /> Nous écrire
                            </a>
                            <a
                                href={settings.googleMapsUrl || `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(settings.address)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-itinerary"
                            >
                                Calculer votre itinéraire
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeContact;
